import React from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';

import { styled } from '../theme';
import { CommonComponentProps } from '../types/components';
import { CaptionText3, SvgIcon, Text } from './index';

const StyledAlert = styled(Text.withComponent('div'))<Props>(
    ({ theme, color, position, direction = 'row' }) => ({
        padding: '10px 30px',
        position: 'relative',
        display: 'flex',
        flexDirection: direction,
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '40px',
        background: theme.color[color],
        color: color === 'text' ? theme.color.jetBlack : theme.color.primaryText,
        borderRadius:
            position === 'top'
                ? `${theme.borderRadius.base}px ${theme.borderRadius.base}px 0 0`
                : `${theme.borderRadius.base}px`,
    })
);

const CloseButton = styled('div')({
    position: 'absolute',
    top: 10,
    right: 20,
    cursor: 'pointer',
});

type Props = CommonComponentProps & {
    color: 'error' | 'warning' | 'success' | 'info' | 'text';
    onClose?: () => void;
    position?: 'top' | 'middle';
    direction?: 'column' | 'row';
    withScrollIntoViewOnMount?: boolean;
};

const Alert: React.FC<Props> = ({
    onClose,
    children,
    position = 'top',
    withScrollIntoViewOnMount,
    ...props
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (withScrollIntoViewOnMount) {
            containerRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
    }, []);

    return (
        <StyledAlert position={position} {...props} ref={containerRef}>
            <CaptionText3>{children}</CaptionText3>
            {onClose && (
                <CloseButton onClick={onClose}>
                    <SvgIcon alt="close" src="/icons/ic-cross.svg" />
                </CloseButton>
            )}
        </StyledAlert>
    );
};

export default Alert;
